// Web Storage throws in a few real browsers (Safari private mode, embedded
// webviews, blocked site data, a full quota). Nothing kept there is worth
// failing a page over, so every access goes through this.
export const safe = (fn, fallback = null) => {
  try {
    return fn();
  } catch (_e) {
    return fallback;
  }
};
